import React from 'react'
import ReactECharts from 'echarts-for-react'
import { EChartsOption } from 'echarts'
import { useTheme } from '../../../components/ThemeProvider'
import { getThemeSecondaryColor } from '../../../utils/themeConfig'

interface InstitutionalApplicationRecordsChartProps {
  data: any
}

export default function InstitutionalApplicationRecordsChart({ data }: InstitutionalApplicationRecordsChartProps) {
  const theme = useTheme()
  const secondaryColor = getThemeSecondaryColor(theme?.type)

  const darkenColor = (color: string, percent: number) => {
    const num = parseInt(color.replace('#', ''), 16)
    const amt = Math.round(2.55 * percent)
    const R = (num >> 16) - amt
    const G = ((num >> 8) & 0x00ff) - amt
    const B = (num & 0x0000ff) - amt
    return `#${(0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1)}`
  }

  const options: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      data: ['传统银行申请次数', '传统银行机构数', '网络零售银行申请次数', '网络零售银行机构数'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: ['近7天', '近15天', '近1月', '近3月', '近6月', '近1年'],
      axisLabel: {
        fontSize: 10,
      },
    },
    yAxis: {
      type: 'value',
      min: 0,
      axisLabel: {
        formatter: '{value}',
      },
    },
    series: [
      {
        name: '传统银行申请次数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: theme?.primaryColor,
        },
        data: [
          data?.b_d7_apply_ctyh_count ?? 0,
          data?.b_d15_apply_ctyh_count ?? 0,
          data?.b_m1_apply_ctyh_count ?? 0,
          data?.b_m3_apply_ctyh_count ?? 0,
          data?.b_m6_apply_ctyh_count ?? 0,
          data?.b_m12_apply_ctyh_count ?? 0,
        ],
      },
      {
        name: '传统银行机构数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: secondaryColor,
        },
        data: [
          data?.b_d7_apply_ctyh_org_count ?? 0,
          data?.b_d15_apply_ctyh_org_count ?? 0,
          data?.b_m1_apply_ctyh_org_count ?? 0,
          data?.b_m3_apply_ctyh_org_count ?? 0,
          data?.b_m6_apply_ctyh_org_count ?? 0,
          data?.b_m12_apply_ctyh_org_count ?? 0,
        ],
      },
      {
        name: '网络零售银行申请次数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: darkenColor(theme?.primaryColor || '#3B82F6', 20),
        },
        data: [
          data?.b_d7_apply_wllsyh_count ?? 0,
          data?.b_d15_apply_wllsyh_count ?? 0,
          data?.b_m1_apply_wllsyh_count ?? 0,
          data?.b_m3_apply_wllsyh_count ?? 0,
          data?.b_m6_apply_wllsyh_count ?? 0,
          data?.b_m12_apply_wllsyh_count ?? 0,
        ],
      },
      {
        name: '网络零售银行机构数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: darkenColor(secondaryColor || '#10B981', 20),
        },
        data: [
          data?.b_d7_apply_wllsyh_org_count ?? 0,
          data?.b_d15_apply_wllsyh_org_count ?? 0,
          data?.b_m1_apply_wllsyh_org_count ?? 0,
          data?.b_m3_apply_wllsyh_org_count ?? 0,
          data?.b_m6_apply_wllsyh_org_count ?? 0,
          data?.b_m12_apply_wllsyh_org_count ?? 0,
        ],
      },
    ],
  }

  return <ReactECharts option={options} style={{ height: '400px' }} />
}
